export const COMMON_INPUT_TEST_ID = 'common-input';
export const COMMON_INPUT_ICON_TEST_ID = 'common-input__icon';
